/**
 * Controle segmentado (ex.: 7/30 dias, Quadro/Lista). Controlado pelo pai;
 * `aria-pressed` + peso/fundo marcam o ativo (nunca só cor).
 */
import { createElement as h, type ReactElement } from "react";
import { cx } from "./cx.js";

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedProps<T extends string> {
  label: string;
  value: T;
  options: Array<SegmentedOption<T>>;
  onChange: (value: T) => void;
}

export function Segmented<T extends string>({ label, value, options, onChange }: SegmentedProps<T>): ReactElement {
  return h(
    "div",
    {
      role: "group",
      "aria-label": label,
      className: "inline-flex rounded-control bg-surface-soft p-1"
    },
    options.map((option) =>
      h(
        "button",
        {
          key: option.value,
          type: "button",
          "aria-pressed": option.value === value,
          onClick: () => onChange(option.value),
          className: cx(
            "min-h-[36px] rounded-control px-3.5 text-sm transition-colors duration-fast ease-s2 focus-visible:outline-none",
            option.value === value ? "bg-surface font-extrabold text-ink shadow-s1" : "font-bold text-muted hover:text-ink"
          )
        },
        option.label
      )
    )
  );
}
